const state = {
  presets: [],
  isLoaded: false
}

export default state
